//   ______
//  /|_||_\`.__
// (   _    _ _\
// =`-(_)--(_)-'  hjw

export const logo = `
&nbsp;&nbsp;______<br />
&nbsp;/|_||_\`.__<br />
(&nbsp;&nbsp;&nbsp;_&nbsp;&nbsp;&nbsp;&nbsp;_ _\\<br />
=\`-(_)--(_)-'  hjw
`;
